

import FormularioCrear from "../components/ComponentsCrear/FormularioCrear/FormularioCrear";

function crearproyectopage(){
    return(
        <>
       
        <FormularioCrear></FormularioCrear>
      
        </>
    );
}


 export default crearproyectopage